module.exports = __webpack_public_path__ + "img/google-plus.852e3cb1.svg";